module.exports = __webpack_public_path__ + "img/businessImg12.299b29da.png";